import { Box, Flex, Input } from '@chakra-ui/react'
import { Dispatch, SetStateAction } from 'react'

import { FormField } from '../../../../components/FormField'
import { AddressAutocomplete, IParsedPlace } from '../../../../components/googleMaps/AddressAutocomplete'
import { EventLocationMap } from '../../../../components/googleMaps/EventLocationMap'
import { GoogleMapsProvider } from '../../../../components/googleMaps/GoogleMapsProvider'
import { MaskedInput } from '../../../../components/MaskedInput'
import { IEventForm } from './eventFormShared'

interface IProps {
  form: IEventForm
  setForm: Dispatch<SetStateAction<IEventForm>>
  fieldErrors: Record<string, string[]>
  saving: boolean
  loadingZip: boolean
  handleZipcode: (cep: string) => void
  handlePlaceSelected: (place: IParsedPlace) => void
  handleMapPositionChange: (lat: number, lng: number, clickedPlaceId?: string) => void
}

export function LocationTab({
  form,
  setForm,
  fieldErrors,
  saving,
  loadingZip,
  handleZipcode,
  handlePlaceSelected,
  handleMapPositionChange
}: IProps) {
  return (
    <GoogleMapsProvider>
      <Box>
        <FormField label="Buscar por nome do local">
          <AddressAutocomplete onPlaceSelected={handlePlaceSelected} disabled={saving} />
        </FormField>
      </Box>

      <Flex gap={3} mt={5}>
        <FormField label="CEP" error={fieldErrors['zipcode']?.[0]} isRequired w="160px">
          <MaskedInput mask="zipCode" value={form.zipcode} onChange={handleZipcode} isDisabled={saving || loadingZip} />
        </FormField>
        <FormField label="Logradouro" htmlFor="street" error={fieldErrors['street']?.[0]} flex="3">
          <Input
            id="street"
            value={form.street}
            onChange={(e) => setForm({ ...form, street: e.target.value })}
            disabled={saving}
            isReadOnly={loadingZip}
          />
        </FormField>
        <FormField label="Número" htmlFor="number" error={fieldErrors['number']?.[0]} w="100px">
          <Input
            id="number"
            value={form.number}
            onChange={(e) => setForm({ ...form, number: e.target.value })}
            disabled={saving}
          />
        </FormField>
      </Flex>

      <Flex gap={3} mt={5}>
        <Box flex="1">
          <FormField label="Complemento" htmlFor="complement">
            <Input
              id="complement"
              value={form.complement}
              onChange={(e) => setForm({ ...form, complement: e.target.value })}
              disabled={saving}
            />
          </FormField>
        </Box>
        <FormField label="Bairro" htmlFor="neighborhood" error={fieldErrors['neighborhood']?.[0]} flex="1">
          <Input
            id="neighborhood"
            value={form.neighborhood}
            onChange={(e) => setForm({ ...form, neighborhood: e.target.value })}
            disabled={saving}
            isReadOnly={loadingZip}
          />
        </FormField>
        <FormField label="Cidade" htmlFor="city" error={fieldErrors['city']?.[0]} flex="1">
          <Input
            id="city"
            value={form.city}
            onChange={(e) => setForm({ ...form, city: e.target.value })}
            disabled={saving}
            isReadOnly={loadingZip}
          />
        </FormField>
        <FormField label="UF" htmlFor="state" error={fieldErrors['state']?.[0]} w="80px">
          <Input
            id="state"
            value={form.state}
            onChange={(e) => setForm({ ...form, state: e.target.value })}
            disabled={saving}
            maxLength={2}
            isReadOnly={loadingZip}
          />
        </FormField>
      </Flex>

      <Flex gap={3} mt={5}>
        <Box flex="1">
          <FormField label="Latitude">
            <Input value={form.latitude?.toString() ?? ''} isReadOnly placeholder="-" />
          </FormField>
        </Box>
        <Box flex="1">
          <FormField label="Longitude">
            <Input value={form.longitude?.toString() ?? ''} isReadOnly placeholder="-" />
          </FormField>
        </Box>
      </Flex>

      <Box mt={5}>
        <FormField label="Arraste o pin ou clique no mapa para definir a localização">
          <EventLocationMap
            latitude={form.latitude}
            longitude={form.longitude}
            onPositionChange={handleMapPositionChange}
          />
        </FormField>
      </Box>
    </GoogleMapsProvider>
  )
}
